export const emojiTypeNameMap = (function (arr) {
    const map = {};
    arr.forEach(it => {
        map[it[1]] = it[0];
    });
    return map;
})([
    ['[微笑]', '1'],
    ['[大笑]', '2'],
    ['[+1]', '3'],
    ['[惊讶]', '4'],
    ['[666]', '5'],
    ['[得意]', '6'],
    ['[生气]', '7'],
    ['[怕怕]', '8'],
    ['[尴尬]', '9'],
    ['[难过]', '10'],
    ['[done]', '11'],
    ['[失望]', '12'],
    ['[呲牙]', '14'],
    ['[色]', '16'],
    ['[流汗]', '17'],
    ['[痴笑]', '18'],
    ['[困]', '19'],
    ['[吐]', '20'],
    ['[疑问]', '21'],
    ['[嘘]', '22'],
    ['[敲打]', '23'],
    ['[闭嘴]', '24'],
    ['[色眯眯]', '26'],
    ['[可爱]', '28'],
    ['[耶]', '29'],
    ['[鄙视]', '31'],
    ['[晕]', '34'],
    ['[抠鼻]', '35'],
    ['[撒娇]', '36'],
    ['[鼓掌]', '37'],
    ['[害羞]', '38'],
    ['[抽烟]', '39'],
    ['[欠揍]', '40'],
    ['[飞吻]', '41'],
    ['[工作忙]', '42'],
    ['[哭泣]', '43'],
    ['[偷笑]', '44'],
    ['[送花]', '45'],
    ['[亲一个]', '46'],
    ['[再见]', '48'],
    ['[飘飘]', '49'],
    ['[秀一下]', '50'],
    ['[囧]', '52'],
    ['[抓狂]', '53'],
    ['[发怒]', '56'],
    ['[傲慢]', '57'],
    ['[玫瑰]', '60'],
    ['[爱心]', '61'],
    ['[心碎]', '62'],
    ['[嘴唇]', '63'],
    ['[踩]', '64'],
    ['[赞]', '65'],
    ['[握手]', '66'],
    ['[刀]', '70'],
    ['[炸弹]', '71'],
    ['[灵感]', '72'],
    ['[叹气]', '94'],
    ['[亲亲]', '95'],
    ['[耍酷]', '96'],
    ['[摸摸]', '97'],
    ['[睫毛弯弯]', '98'],
    ['[发呆]', '100'],
    ['[睡]', '101'],
    ['[大哭]', '102'],
    ['[吐舌]', '103'],
    ['[白眼]', '104'],
    ['[奋斗]', '105'],
    ['[咒骂]', '106'],
    ['[衰]', '107'],
    ['[骷髅]', '108'],
    ['[擦汗]', '109'],
    ['[坏笑]', '110'],
    ['[左哼哼]', '111'],
    ['[右哼哼]', '112'],
    ['[哈欠]', '113'],
    ['[委屈]', '114'],
    ['[快哭了]', '115'],
    ['[阴险]', '116'],
    ['[可怜]', '117'],
    ['[拥抱]', '118'],
    ['[蛋糕]', '119'],
    ['[猪头]', '120'],
    ['[抱拳]', '121'],
    ['[强壮]', '122'],
    ['[OK]', '123'],
    ['[生病]', '124'],
    ['[破涕为笑]', '125'],
    ['[脸红]', '126'],
    ['[恐惧]', '127'],
    ['[嘿哈]', '128'],
    ['[捂脸哭]', '129'],
    ['[奸笑]', '130'],
    ['[机智]', '131'],
    ['[皱眉]', '132'],
    ['[吃瓜]', '133'],
    ['[天啊]', '134'],
    ['[社会社会]', '135'],
    ['[旺柴]', '136'],
    ['[好的]', '137'],
    ['[打脸]', '138'],
    ['[惊喜]', '139'],
    ['[幽灵]', '140'],
    ['[合十]', '141'],
    ['[钱]', '142'],
    ['[戳脸]', '143'],
    ['[思考]', '144'],
    ['[送花花]', '145'],
    ['[yes]', '150'],
    ['[no]', '151'],
    ['[ok]', '152'],
    ['[get]', '153'],
]);
export var CustomMessageEvents;
(function (CustomMessageEvents) {
    CustomMessageEvents["CREATE_P2P_SESSION"] = "CREATE_P2P_SESSION";
    CustomMessageEvents["CREATE_TEAM_SESSION"] = "CREATE_TEAM_SESSION";
})(CustomMessageEvents || (CustomMessageEvents = {}));
